(() => {
  const cardSelector = 'product-card.card--product';
  const titleSelector = '.card__title';
  let animationFrame;

  const alignProductCardTitles = () => {
    cancelAnimationFrame(animationFrame);

    animationFrame = requestAnimationFrame(() => {
      const cards = Array.from(document.querySelectorAll(cardSelector))
        .filter(card => card.offsetParent !== null);

      cards.forEach(card => {
        card.style.removeProperty('--product-card-title-height');
      });

      const rows = [];

      cards.forEach(card => {
        const title = card.querySelector(titleSelector);

        if (!title) return;

        const top = Math.round(card.getBoundingClientRect().top);

        let row = rows.find(item => Math.abs(item.top - top) <= 2);

        if (!row) {
          row = {
            top,
            items: []
          };

          rows.push(row);
        }

        row.items.push({
          card,
          title
        });
      });

      rows.forEach(row => {
        if (row.items.length < 2) return;

        const maxHeight = Math.ceil(
          Math.max(
            ...row.items.map(item => item.title.getBoundingClientRect().height)
          )
        );

        row.items.forEach(item => {
          item.card.style.setProperty(
            '--product-card-title-height',
            `${maxHeight}px`
          );
        });
      });
    });
  };

  const observer = new MutationObserver(() => {
    alignProductCardTitles();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('resize', alignProductCardTitles);

  document.addEventListener('shopify:section:load', alignProductCardTitles);
  document.addEventListener('shopify:section:reorder', alignProductCardTitles);

  if (document.fonts) {
    document.fonts.ready.then(alignProductCardTitles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alignProductCardTitles);
  } else {
    alignProductCardTitles();
  }
})();